import React, { FC } from 'react';
import styled from 'styled-components';

import { Match } from '../../../../database.schema';
import { MatchPlayer } from './match-player';
import { SetMatchResult } from './set-match-result';

export const TeamWrapper = styled.div<{ bgColor?: string | null }>`
  border: 1px solid black;
  width: 8rem;
  background: ${(props) => props.bgColor || '#eae6e6'};
  color: white;
  padding: 5px;
  min-height: 2rem;
  margin: 0.25rem 0;
  text-align: center;
`;
const DropWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

type Props = {
  recordedMatch: Match[];
  onChangePlayerScore: (points: number, playerIndex: number, matchIndex: number, team: string) => void;
  onMatchResultChange: (result: string, matchIndex: number) => void;
  onMatchMarginChange: (margin: string, matchIndex: number) => void;
};

export const ResultEntrySingles: FC<Props> = ({ recordedMatch, onChangePlayerScore, onMatchMarginChange, onMatchResultChange }): JSX.Element | null => {
  return (
    <div>
      {recordedMatch.map((match: Match, index: number) => (
        <div key={`result-${index}`}>
          <h3>{`Singles Entry ${index + 1}`}</h3>
          <DropWrapper data-testid={`singles-${index}`}>
            <MatchPlayer
              match={match}
              playerIndex={0}
              player={recordedMatch[index].team1.players?.[0]}
              team="team1"
              bgColor="red"
              matchIndex={index}
              onChangePlayerScore={onChangePlayerScore}
            />
            <SetMatchResult match={match} matchIndex={index} onMatchResultChange={onMatchResultChange} onMatchMarginChange={onMatchMarginChange} />
            <MatchPlayer
              match={match}
              playerIndex={0}
              player={recordedMatch[index].team2.players?.[0]}
              team="team2"
              bgColor="blue"
              matchIndex={index}
              onChangePlayerScore={onChangePlayerScore}
            />
          </DropWrapper>
        </div>
      ))}
    </div>
  );
};
